import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from '@mui/icons-material/Edit';
import request from "../../../Helpers/API";
import CollectionsIcon from '@mui/icons-material/Collections';
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import AgricultureIcon from '@mui/icons-material/Agriculture';
import { BuscadorModelosPromocion } from "../PromocionesModelo/BuscadorModelosPromocion";
import { EsquemasporModeloModal } from "./EsquemasporModeloModal";
import VisibilityIcon from '@mui/icons-material/Visibility';

export const PromocionesModelosListadoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [modelos, setModelos] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEsquemas, setOpenModalEsquemas] = useState(false);
    const [idmodeloselect, setidModeloSelect] = useState();
    const [modeloselect, setModeloSelect] = useState();
    const [lineaSeleccionada, setLineaSeleccionada] = useState(1);
    const [lineasDisponibles, setLineasDisponibles] = useState([]);
    const [esquemaSeleccionado, setEsquemaSeleccionado] = useState(-1);
    const [esquemas, setEsquemas] = useState([]);
    const [datafiltro, setDatafiltro] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState(false);
    const [keyFiltrado, setKeyFiltrado] = useState("")

    const handleLineaChange = (event) => {
        setLineaSeleccionada(event.target.value);
        setEsquemaSeleccionado(-1)
    };
    const handleEsquemaChange = (event) => {
        setEsquemaSeleccionado(event.target.value);
    };
    console.log(lineasDisponibles)
    const [selectedFilters, setSelectedFilters] = useState({
        modelo: [],
        descripcion: []
    });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModalEsquemas = (id, modelo) => {
        setidModeloSelect(id);
        setModeloSelect(modelo);
        setOpenModalEsquemas(true);
    };

    const handleCloseModalEsquemas = () => {
        setidModeloSelect(null);
        setModeloSelect(null);
        setOpenModalEsquemas(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoader(prev => ({ ...prev, mostrar: true }));

            try {
                const requests = [
                    request.get(`PromocionesDisponibles/ModelosenEsquema?idlinea=${lineaSeleccionada}&esquema=${esquemaSeleccionado}`),
                    request.get(`ListadoModelos/LineasDropDownList`)
                ];

                const [result1, result2] = await Promise.all(requests);

                console.log(result1)
                setModelos(result1.modelos);
                setEsquemas(result1.esquemas)
                setLineasDisponibles(result2);
            } catch (error) {
                Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
            } finally {
                setLoader(prev => ({ ...prev, mostrar: false }));
            }
        };

        fetchData();
    }, [lineaSeleccionada, esquemaSeleccionado]);

    const onGeneraPDF = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`PromocionesDisponibles/ModelosenEsquemaPDF?idlinea=${lineaSeleccionada}&esquema=${esquemaSeleccionado}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Clientes", JSON.stringify(error), "error");
                });
    };

    return (
        <PlantillaScreen
            titulo={`ESQUEMAS DE PAGO DE MODELOS`}
            className={"promociones-modelos-main-screen"}
            className_main={1}
        >
            <div className="promociones-modelos-actions">
                <div
                    className="promociones-modelos-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button className="PDF"
                        onClick={() =>
                            onGeneraPDF()
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div>
            </div>
            <div className="promociones-modelos">
                <LoaderScreen loader={loader} />
                <div className="promociones-modelos-filtro">
                    <FormControl fullWidth size="small" sx={{ mb: 2, height: '40px' }}>
                        <InputLabel id="linea-select-label">Mostrar Línea</InputLabel>
                        <Select
                            labelId="linea-select-label"
                            value={lineaSeleccionada}
                            label="Filtrar por Línea"
                            onChange={handleLineaChange}
                        >
                            {lineasDisponibles.map((linea, index) => (
                                <MenuItem key={linea.idlinea} value={linea.idlinea}>
                                    {capitalizePalabras(linea.descripcion)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small" sx={{ mb: 2, height: '40px', ml: 2 }}>
                        <InputLabel id="linea-select-label">Esquema</InputLabel>
                        <Select
                            labelId="linea-select-label"
                            value={esquemaSeleccionado}
                            label="Filtrar por Esquema"
                            onChange={handleEsquemaChange}
                        >
                            {/* MenuItems adicionales fijos */}
                            {/* <MenuItem value={0}>Todos</MenuItem> */}
                            <MenuItem value={-1}>Precio de Lista</MenuItem>

                            {/* MenuItems dinámicos basados en la lista de esquemas */}
                            {esquemas.map((esquema) => (
                                <MenuItem key={esquema.idpromocion} value={esquema.idpromocion}>
                                    {capitalizePalabras(esquema.descripcion_promocion)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <BuscadorModelosPromocion
                        data={modelos}
                        datafiltro={datafiltro}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        setDatafiltro={setDatafiltro}
                        filtrar={filtroEstado}
                        setFiltrar={setFiltroEstado}
                        keyFiltrado={keyFiltrado}
                    />

                </div>
                <div className="promociones-modelos-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Línea
                                </th>
                                <th>
                                    <div>Modelo</div>
                                </th>
                                <th>
                                    <div>Descripción</div>
                                </th>
                                <th>
                                    <div>Precio normal</div>
                                </th>
                                {/* <th>
                                    <div>Esquemas de pago</div>
                                </th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {datafiltro
                                .filter((mo) => !lineaSeleccionada || mo.idlinea === lineaSeleccionada)
                                .map((mo) => (
                                    <tr key={mo.idmodelo}>
                                        <td className="celda-modelo">
                                            <div>{mo.linea}</div>
                                        </td>
                                        <td className="celda-modelo">{mo.modelo}</td>
                                        <td className="celda-descripcion">{mo.descripcion}</td>
                                        <td className="celda-importe">{FormatMoney(mo.precio_lista)}</td>
                                        {/* <td className="celda-esquema">
                                            <div className="modelos-acciones-listado">
                                                {mo.registrado_esquema === 'S' ? (
                                                    <div
                                                        className="boton-editar-modelos"
                                                        onClick={() => handleOpenModalEsquemas(mo.idmodelo, mo.modelo)}
                                                    >
                                                        <VisibilityIcon /> Ver esquemas
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="boton-sin-esquema"
                                                    >
                                                        Sin esquema
                                                    </div>
                                                )}
                                            </div>
                                        </td> */}

                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <EsquemasporModeloModal
                    open={openModalEsquemas}
                    onClose={handleCloseModalEsquemas}
                    id={idmodeloselect}
                    modelo={modeloselect}
                />
            </div>
        </PlantillaScreen>
    );
};
